import React from "react";

function ApplicationStatusSteps(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="30"
      viewBox="0 0 2 30"
      fill="currentColor"
      {...props}
    >
      <path
        d="M1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1H1.5ZM0.5 1V2.03571H1.5V1H0.5ZM0.5 4.10714L0.5 6.17857H1.5L1.5 4.10714H0.5ZM0.5 8.25L0.5 10.3214H1.5V8.25H0.5ZM0.5 12.3929L0.5 14.4643H1.5L1.5 12.3929H0.5ZM0.5 16.5357L0.5 18.6071H1.5L1.5 16.5357H0.5ZM0.5 20.6786L0.5 22.75H1.5V20.6786H0.5ZM0.5 24.8214L0.5 26.8929H1.5L1.5 24.8214H0.5ZM0.5 28.9643V30H1.5V28.9643H0.5ZM1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1H1.5ZM0.5 1V2.03571H1.5V1H0.5ZM0.5 4.10714L0.5 6.17857H1.5L1.5 4.10714H0.5ZM0.5 8.25L0.5 10.3214H1.5V8.25H0.5ZM0.5 12.3929L0.5 14.4643H1.5L1.5 12.3929H0.5ZM0.5 16.5357L0.5 18.6071H1.5L1.5 16.5357H0.5ZM0.5 20.6786L0.5 22.75H1.5V20.6786H0.5ZM0.5 24.8214L0.5 26.8929H1.5L1.5 24.8214H0.5ZM0.5 28.9643V30H1.5V28.9643H0.5Z"
        fill={props.fill}
      />
    </svg>
  );
}

const MemoApplicationStatusSteps = React.memo(ApplicationStatusSteps);
export default MemoApplicationStatusSteps;
